module.exports =
  '_CLUB_PAGE':
    'PAGE_TITLE': "Club"
    'SCORE_CARD': 'スコアカード'
    'NO_ROUND_PLAYED': 'このコースにはまだスコア記録がありません。'
    'HOLE_BY_HOLE_AVG': 'GN+ユーザー平均'
    'SHOT_AVG': '平均スコア'
    'PUTT_AVG': '平均パット'
    'SCORE_AVG': '平均ストローク数'
    'PUTT_AVG_COUNT': '平均パット数'
    'STROKE_PUTT': 'ストローク/パット'
    'GIR_GIR1': 'パーオン/ボギーオン'
    'RECOVERY': 'リカバリー率'
    'ADDRESS': '住所'
    'TEL': 'TEL'
    'URL': 'URL'
    'HEADER_TITLE_LARGE': 'みんなのスコア'
    'HEADER_TITLE_SMALL': '- 100万人のスコアデータ公開中 -'
    'CHART_HEADING': '現在120万人のスコアデータからアドバイス中'
    'CHANCE_HOLE': 'チャンスホール'
    'ONE_PUTT': '目指せ！１パット'
    'DIFFICULT_HOLE': '難関ホール'
    'THREE_PUTTS': '３パット注意！'
    'YARDAGE': 'ヤーデージ'
    'SEE_REVIEWS': 'このゴルフ場の口コミを見る'
    'HOLE_ADVICE': 'ホールアドバイス'
    'COURSE_SELECT': 'コース選択'
    'BASIC_INFO': 'ゴルフ場基本情報'
    'RECOMMENT_PLAN': 'おすすめプラン'
    'SEE_MORES_RECOMMENT_PLAN': 'おすすめプランをもっと見る'
    'RECENT_PLAYED_USERS': '最近ラウンドしたユーザー'
    'RANKING_USERS': 'ベストスコアランキング'
    'RANK': '順位'
    'NAME': 'ニックネーム / 名前'
    'SCORE': 'スコア'
    'RANKING_NOTICE': '対象：ニックネームまたは名前が設定されているユーザー'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/club/i18n/ja.coffee